<template>
  <MatchMedia query="(max-width: 768px)" v-slot="{ matches }">
    <BottleEditMobile  v-if="matches" />
    <BottleEditDesktop v-else />
  </MatchMedia>
</template>
 
<script>
  import { MatchMedia } from "vue-component-media-queries";
  import BottleEditMobile from "./BottleEdit_Mobile.vue";
  import BottleEditDesktop from "./BottleEdit_Desktop.vue";
 
  export default {
    name: 'BottleEdit',
    components: {
      MatchMedia,
      BottleEditMobile,
      BottleEditDesktop,
    },
  }
</script> 